/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendBusinessAngelDividendDto } from '../../models/backend-business-angel-dividend-dto';
import { BackendBusinessAngelDividendRequestDto } from '../../models/backend-business-angel-dividend-request-dto';

export interface VentureFundsBusinessAngelDividendsCreate$FormData$Params {
  body: BackendBusinessAngelDividendRequestDto;
}

export function ventureFundsBusinessAngelDividendsCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsBusinessAngelDividendsCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendBusinessAngelDividendDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsBusinessAngelDividendsCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendBusinessAngelDividendDto>;
    }),
  );
}

ventureFundsBusinessAngelDividendsCreate$FormData.PATH = '/api/venture_funds/business-angel-dividends/';
